import dayjs from 'dayjs';
import { useMemo } from 'react';

const PAGE_SIZE = 15;

const getRecordValue = (record, keys, fallback = '-') => {
  if (!record || !Array.isArray(keys)) return fallback;

  for (let index = 0; index < keys.length; index += 1) {
    const key = keys[index];
    const value = record?.[key];

    if (value === 0) return 0;
    if (value !== undefined && value !== null && `${value}`.trim() !== '') {
      return value;
    }
  }

  return fallback;
};

const ScoreHistoryTable = ({
  data = [],
  isLoading = false,
  page = 1,
  onPageChange,
  onClaimReward
}) => {
  const total = data.length;
  const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));
  const currentPage = Math.min(Math.max(page, 1), totalPages);

  const pageRows = useMemo(() => {
    const start = (currentPage - 1) * PAGE_SIZE;
    return data.slice(start, start + PAGE_SIZE);
  }, [currentPage, data]);

  return (
    <div className="overflow-x-auto rounded-[10px] border border-[#8abc97]">
      <table className="w-full min-w-[1120px] border-separate border-spacing-0 text-center text-[11px] md:text-[14px] text-[#0f6b2c]">
        <thead>
          <tr className="bg-[#006a1f] text-[#f4e251]">
            <th className="border-r border-b border-[#8abc97] px-2 py-3 text-[12px] md:text-[16px] font-bold uppercase">
              Ngày dự đoán
            </th>
            <th className="border-r border-b border-[#8abc97] px-2 py-3 text-[12px] md:text-[16px] font-bold uppercase">
              Trận đấu
            </th>
            <th className="border-r border-b border-[#8abc97] px-2 py-3 text-[12px] md:text-[16px] font-bold uppercase">
              Dự đoán
            </th>
            {/* <th className="border-r border-b border-[#8abc97] px-2 py-3 text-[12px] md:text-[16px] font-bold uppercase">
              Dự đoán giống bạn
            </th> */}
            <th className="border-r border-b border-[#8abc97] px-2 py-3 text-[12px] md:text-[16px] font-bold uppercase">
              Cấp VIP
            </th>
            <th className="border-r border-b border-[#8abc97] px-2 py-3 text-[12px] md:text-[16px] font-bold uppercase">
              Kết quả
            </th>
            <th className="border-r border-b border-[#8abc97] px-2 py-3 text-[12px] md:text-[16px] font-bold uppercase">
              Điểm thưởng
            </th>
            <th className="border-b border-[#8abc97] px-2 py-3 text-[12px] md:text-[16px] font-bold uppercase">
              Nhận thưởng
            </th>
          </tr>
        </thead>

        <tbody>
          {isLoading ? (
            <tr className="bg-[#dce3df]">
              <td
                colSpan={8}
                className="border-b border-[#8abc97] px-2 py-4 text-[13px] md:text-[15px]"
              >
                Đang tải...
              </td>
            </tr>
          ) : pageRows.length === 0 ? (
            <tr className="bg-[#dce3df]">
              <td
                colSpan={8}
                className="border-b border-[#8abc97] px-2 py-4 text-[13px] md:text-[15px]"
              >
                Không có dữ liệu
              </td>
            </tr>
          ) : (
            pageRows.map((record, idx) => {
              const parsedDate = dayjs(record?.createdAt);
              const homeName = (record?.homeName || '').trim();
              const awayName = (record?.awayName || '').trim();
              const hasHomeScore =
                record?.homeScore !== undefined &&
                record?.homeScore !== null &&
                record?.homeScore !== '';
              const hasAwayScore =
                record?.awayScore !== undefined &&
                record?.awayScore !== null &&
                record?.awayScore !== '';
              const rewardStatus = getRecordValue(
                record,
                [
                  'status_register',
                  'statusRegister',
                  'register_status',
                  'received',
                  'isReceived',
                  'claimed',
                  'isClaimed',
                  'isReceiveReward',
                  'isClaimedReward'
                ],
                null
              );
              const normalizedRewardStatus =
                typeof rewardStatus === 'string' ? rewardStatus.trim().toLowerCase() : rewardStatus;
              const isClaimed =
                normalizedRewardStatus === true ||
                normalizedRewardStatus === 1 ||
                normalizedRewardStatus === '1' ||
                normalizedRewardStatus === 'accept';

              const isApply = normalizedRewardStatus === 'apply';
              const matchResult = record?.match_result;
              const hasMatchResult =
                matchResult !== undefined &&
                matchResult !== null &&
                `${matchResult}`.trim() !== '';
              const showCancelled = !hasMatchResult && normalizedRewardStatus === 'deny';

              return (
                <tr
                  key={record?._id || `${record?.matchId}-${record?.createdAt}-${idx}`}
                  className="bg-[#dce3df]"
                >
                  <td className="border-r border-b border-[#8abc97] px-2 py-3 text-[11px] md:text-[15px]">
                    {parsedDate.isValid() ? parsedDate.format('DD/MM/YYYY HH:mm') : '-'}
                  </td>
                  <td className="border-r border-b border-[#8abc97] px-2 py-3 text-left md:text-[15px]">
                    <span className="block text-[11px] md:text-[15px] leading-[1.25]">
                      {homeName && awayName
                        ? `${homeName} - ${awayName}`
                        : homeName || awayName || '-'}
                    </span>
                  </td>
                  <td className="border-r border-b border-[#8abc97] px-2 py-3 md:text-[15px]">
                    {hasHomeScore && hasAwayScore ? `${record.homeScore}-${record.awayScore}` : '-'}
                  </td>
                  {/* <td className="border-r border-b border-[#8abc97] px-2 py-3 md:text-[15px]">
                    {getRecordValue(record, [
                      'samePredictionCount',
                      'samePredictCount',
                      'sameVoteCount',
                      'sameCount',
                      'predictLikeCount',
                      'countSamePrediction',
                      'count'
                    ])}
                  </td> */}
                  <td className="border-r border-b border-[#8abc97] px-2 py-3 md:text-[15px]">
                    {getRecordValue(record, ['vipLevel', 'vip', 'vip_rank', 'levelVip'])}
                  </td>
                  <td className="border-r border-b border-[#8abc97] px-2 py-3 md:text-[15px]">
                    {showCancelled ? (
                      <span className="font-semibold text-red-600">Hủy</span>
                    ) : (
                      (record?.match_result || '-').toString()
                    )}
                  </td>
                  <td className="border-r border-b border-[#8abc97] px-2 py-3 md:text-[15px]">
                    {getRecordValue(record, [
                      'point',
                      'points',
                      'rewardPoint',
                      'rewardPoints',
                      'bonusPoint',
                      'bonusPoints'
                    ])}
                  </td>
                  <td className="border-b border-[#8abc97] px-2 py-3 md:text-[15px]">
                    <div className="flex justify-center">
                      <button
                        type="button"
                        onClick={() => onClaimReward?.(record)}
                        disabled={!isApply}
                        className={`rounded-md border-none px-1 py-2 text-xs font-semibold text-white md:rounded-lg md:px-3 md:text-sm ${
                          isApply
                            ? 'cursor-pointer bg-gradient-to-b from-[#00CD32] to-[#048724]'
                            : 'cursor-not-allowed bg-[#9ea3a7]'
                        }`}
                      >
                        {isClaimed ? 'Đã nhận thưởng' : 'Nhận thưởng'}
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>

      {!isLoading && total > PAGE_SIZE ? (
        <div className="flex items-center justify-end gap-2 border-t border-[#8abc97] bg-[#dce3df] px-3 py-2 text-[12px] md:text-[14px]">
          <button
            type="button"
            onClick={() => onPageChange?.(currentPage - 1)}
            disabled={currentPage <= 1}
            className="rounded border border-[#8abc97] px-2 py-1 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Trước
          </button>
          <span className="min-w-[86px] text-center">
            {currentPage}/{totalPages}
          </span>
          <button
            type="button"
            onClick={() => onPageChange?.(currentPage + 1)}
            disabled={currentPage >= totalPages}
            className="rounded border border-[#8abc97] px-2 py-1 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Sau
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default ScoreHistoryTable;
